import { MAV } from '../../constants';
import { defaultFactory as request } from '../../api/RequestFactory';
import { mavRequest } from './requestFactory';
import FSA from '../FSA';

import { ISystemEvents, fetchEvents } from './Event';

function fetchNodes(requesterId: string, query): any {
    return request.post('me/query', query);
}

function fetchInformation(requesterId: string, containerIds: string[]): any {
    const query = {
        ContainerIdList: containerIds.map((id) => {
            return {
                ContainerId: id
            };
        })
    };

    return mavRequest.post('container/get', query).then((systems) => {
        return systems.reduce((r, system) => {
            r[system.ContainerId] = system.VirusInfo;
            return r;
        }, {});
    });
}

function assignInformation(nodes, information) {
    return nodes.map((node) => {
        node.virusInformation = information[node.id];
        return node;
    });
}

export function listSystems(requesterId: string, query?): any {
    return dispatch => {
        dispatch(new FSA(MAV.FETCH_SYSTEMS_REQUEST).addMeta({ requesterId, query }).data);

        return fetchNodes(requesterId, query).then(nodes => {
            const containerIds = nodes.map((node) => {
                return node.id;
            });

            return fetchInformation(requesterId, containerIds).then((information) => {
                return assignInformation(nodes, information);
            });
        }).then(nodes => {
            return dispatch(new FSA(MAV.FETCH_SYSTEMS_SUCCESS).addPayload(nodes).addMeta({ requesterId, query }).data);
        }).catch(err => {
            dispatch(new FSA(MAV.FETCH_SYSTEMS_FAILURE).addError(err).addMeta({ requesterId, query }).data);
            throw err;
        });
    }
}

export function listSystemsWithEvents(requesterId: string, query, softwareParams) {
    return dispatch => {
        dispatch(new FSA(MAV.FETCH_SYSTEMS_WITH_EVENTS_REQUEST).addMeta({ requesterId, query }).data);

        return fetchNodes(requesterId, query).then(nodes => {
            const containerIds = nodes.map((node) => {
                return node.id;
            });

            return fetchInformation(requesterId, containerIds).then((information) => {
                return assignInformation(nodes, information);
            });
        }).then(nodes => {
            const systemIds = nodes.filter(node => {
                return !!node.virusInformation;
            }).map(node => {
                return node.id;
            });

            softwareParams = softwareParams || {};
            softwareParams.containerIds = systemIds;

            return fetchEvents(requesterId, softwareParams).then(events => {
                nodes.forEach(node => {
                    if(node.virusInformation && events[node.id]) {
                        node.virusInformation.Count = events[node.id].length;
                    }
                });

                return dispatch(new FSA(MAV.FETCH_SYSTEMS_WITH_EVENTS_SUCCESS).addPayload({
                    systems: nodes,
                    events
                }).addMeta({ requesterId, query }).data);
            });

        }).catch(err => {
            dispatch(new FSA(MAV.FETCH_SYSTEMS_WITH_EVENTS_FAILURE).addError(err).addMeta({ requesterId, query }).data);
            throw err;
        });
    }
}


// WEBPACK FOOTER //
// ./src/actions/mav/System.ts